import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuDropdownOption} from '@Components/contextual-menu/components/contextual-menu-dropdown-option';
import {SeparatorType} from '@PosterWhiteboard/items/tabs-item/tabs-item.class';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTabItem} from '@Hooks/poster-editor/useGetKeyFromTabItem';

interface SeparatorStyleOptionProps {
  onClickColorFill(): void;
}

export function SeparatorStyleOption({...props}: SeparatorStyleOptionProps): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemSeparatorType = useGetKeyFromTabItem('separatorType') as SeparatorType;
  const itemSeparatorColor = useGetKeyFromTabItem('separatorColor');

  if (!activeItem) {
    throw new Error('Active Item is null');
  }

  if (!activeItem.isTab() || itemSeparatorType === undefined || !itemSeparatorColor) {
    throw new Error(`Expected tab item, instead got ${activeItem.gitype}`);
  }

  const onClickHandler = (id: SeparatorType): void => {
    void activeItem.updateFromObject({
      separatorType: Number(id),
    });
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const getData = (): ColorFillStorage[] => {
    return [
      {
        id: 'seperator-color-object',
        color: getColorObjectArrayFromFillColor([itemSeparatorColor]),
      },
    ];
  };

  const getSubOptions = (): ReactElement | null => {
    if (itemSeparatorType !== SeparatorType.NONE) {
      return <ContextualMenuColorFillOption id="separator-type-color-option" label={window.i18next.t('pmwjs_color')} data={getData()} onClick={onClickColorFill} />;
    }
    return null;
  };

  return (
    <ContextualMenuDropdownOption
      id="tab-separator-option"
      label={window.i18next.t('pmwjs_style')}
      dropdownItems={[
        {id: SeparatorType.NONE, text: window.i18next.t('pmwjs_none')},
        {id: SeparatorType.SOLID, text: window.i18next.t('pmwjs_solid_line')},
        {id: SeparatorType.DASHED, text: window.i18next.t('pmwjs_dashed')},
      ]}
      onClick={onClickHandler}
      selectedItemId={itemSeparatorType}
    >
      {getSubOptions()}
    </ContextualMenuDropdownOption>
  );
}
